
import useScrollAnimation from '../../../hooks/useScrollAnimation';

export default function Process() {
  const ref = useScrollAnimation();

  const steps = [
    {
      number: '01',
      title: 'Assess',
      description: 'Comprehensive operational audit and system review.',
      icon: 'ri-search-eye-line',
    },
    {
      number: '02',
      title: 'Clarify',
      description: 'Identify inefficiencies, opportunities, and automation leverage points.',
      icon: 'ri-focus-3-line',
    },
    {
      number: '03',
      title: 'Architect',
      description: 'Design intelligent systems aligned to long-term growth.',
      icon: 'ri-draft-line',
    },
    {
      number: '04',
      title: 'Elevate',
      description: 'Implement, optimize, and continuously refine performance.',
      icon: 'ri-rocket-line',
    },
  ];

  return (
    <section ref={ref} id="process" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-8 lg:px-12">
        <div className="text-center mb-20">
          <p className="animate-on-scroll text-[13px] font-medium text-anchor tracking-wide uppercase mb-4">How We Work</p>
          <h2 className="animate-on-scroll text-4xl md:text-5xl font-light text-navy mb-5 tracking-tight" style={{ transitionDelay: '0.1s' }}>
            Our Approach to Elevation
          </h2>
        </div>

        {/* Large visual */}
        <div className="animate-on-scroll mb-16" style={{ transitionDelay: '0.15s' }}>
          <div className="relative rounded-2xl overflow-hidden">
            <div className="w-full h-[280px] md:h-[380px]">
              <img
                src="https://public.readdy.ai/ai/img_res/975321c0118be19c2d676764a3f4a4a5.jpg"
                alt="SkySails AI systematic process approach"
                title="SkySails AI - Strategic process methodology"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-white via-white/30 to-transparent"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div
              key={index}
              className="animate-on-scroll group relative"
              style={{ transitionDelay: `${0.15 + 0.1 * index}s` }}
            >
              <div className="bg-drift rounded-2xl p-8 h-full hover:bg-horizon/50 transition-all duration-500">
                {/* Step connector line */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-12 right-0 w-6 h-px bg-navy/10 translate-x-3"></div>
                )}

                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white">
                    <i className={`${step.icon} text-lg text-anchor`}></i>
                  </div>
                  <span className="text-[13px] font-medium text-navy/25">{step.number}</span>
                </div>

                <h3 className="text-xl font-medium text-navy mb-3 tracking-tight">
                  {step.title}
                </h3>
                <p className="text-sm text-navy/45 leading-relaxed font-light">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
